var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLqiDirectionUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8502 15.1C4.8502 14.26 5.1202 13.34 5.6602 12.41L8.3302 7.78C9.2802 6.15 10.5802 5.25 12.0002 5.25C13.4202 5.25 14.7202 6.15 15.6602 7.78L18.3302 12.41C19.2702 14.04 19.4002 15.61 18.6902 16.85C17.9802 18.08 16.5502 18.76 14.6702 18.76H9.3302C7.4502 18.76 6.0202 18.08 5.3102 16.85C5.0002 16.32 4.8502 15.73 4.8502 15.1ZM17.6402 15.1C17.6402 14.52 17.4402 13.86 17.0302 13.16L14.3602 8.53C13.7002 7.38 12.8602 6.75 12.0002 6.75C11.1402 6.75 10.3002 7.38 9.6402 8.53L6.9702 13.16C6.3102 14.31 6.1802 15.35 6.6102 16.1C7.0402 16.85 8.0102 17.26 9.3302 17.26H14.6702C15.9902 17.26 16.9602 16.85 17.3902 16.1C17.5602 15.8 17.6402 15.46 17.6402 15.1Z",
    fill: "#0ABAB5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLqiDirectionUp);
export default __webpack_public_path__ + "static/media/lqi_direction_up.f61d400318f3dd355c098357c72e0f0d.svg";
export { ForwardRef as ReactComponent };